import dayjs from 'dayjs';
import { Card } from '@mui/material';
import { EntityHistoryTimelineEntryDto } from '../entity-history-timeline.types';
import { EntityHistoryTimelineChange } from '../entity-history-timeline-change/entity-history-timeline-change.component';
import { EntityHistoryTimelineReferences } from '../entity-history-timeline-references/entity-history-timeline-references.component';
import { TimelineIcon } from '../../timeline/timeline-icon/timeline-icon.component';
import { Colors } from '../../../../theme/colors';
import { useEntityHistoryEventStyles } from './entity-history-timeline-event.styles';

export function EntityHistoryTimelineEvent({
  event,
  isLast
}: {
  event: EntityHistoryTimelineEntryDto;
  isLast: boolean;
}) {
  const classes = useEntityHistoryEventStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.row}>
        <div className={classes.icon}>
          <TimelineIcon color={Colors.deliveredBlue} />
        </div>
        <div className={classes.content}>
          <span className={classes.displayName}>{event.displayName}</span>
          {event.references && event.references.length > 0 && (
            <EntityHistoryTimelineReferences references={event.references} />
          )}
          <span className={classes.timestamp}>{dayjs(event.timestamp).format('DD MMM YYYY, HH:mm')}</span>
          {event.changes && event.changes.length > 0 && (
            <Card className={classes.bubble}>
              <p className={classes.bubbleTitle}>Changes</p>
              {event.changes.map((change, index) => (
                <EntityHistoryTimelineChange key={`${change.field}-${index}`} change={change} />
              ))}
            </Card>
          )}
        </div>
      </div>
      {!isLast && <div className={classes.divider} />}
    </div>
  );
}
